/**
 * Site-wide settings: defaults the default language.
 *
 * @module config/settings
 */
import type { ConfigType } from '@plone/registry';

/** The language the sign-in pages are served in. */
export const DEFAULT_LANGUAGE = 'en';

/**
 * Apply settings: set default language only.
 *
 * `supportedLanguages` is left unchanged to preserve consuming project
 * translations.
 *
 * @param config The Volto configuration registry.
 * @returns The same registry, for chaining.
 */
export default function install(config: ConfigType) {
  config.settings.defaultLanguage = DEFAULT_LANGUAGE;

  return config;
}
